const dictionary = {
  ko: {
    // -----------------------------------------------------------------------------------------------
    // 기부 신청서 start
    // -----------------------------------------------------------------------------------------------
    dntn_aplc_001: '주문번호가 존재하지 않습니다.',
    dntn_aplc_002: '이름을 입력해 주세요.',
    dntn_aplc_003: '주민번호를 입력해 주세요.',
    dntn_aplc_004: '주민번호가 유효하지 않습니다.',
    dntn_aplc_005: '필수사항에 모두 동의하셔야 기부하실수 있습니다.',
    dntn_aplc_006: '이미 기부 신청 되었습니다.',
    dntn_aplc_007: '기부신청 하시겠습니까?',
    dntn_aplc_008: '기부신청이 완료 되었습니다.',
    dntn_aplc_009: '기부신청시 오류가 발생하였습니다.',
    dntn_aplc_010: '조회시 오류가 발생하였습니다.'
    // -----------------------------------------------------------------------------------------------
    // 기부 신청서 end
    // -----------------------------------------------------------------------------------------------
  }
}

export default {
  getDictionary () {
    return dictionary
  }
}



// WEBPACK FOOTER //
// ./src/locale/purchase/purchase-dict-ko.js